import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileService } from 'app/services';
import { MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';

@Component({
    selector: 'app-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.scss'],
    standalone: false
})
export class ImageUploadComponent implements OnInit {

  imageFor: string;
  formSubmitted: boolean = false;
  public imagePath;
  imgURL: any;
  fileToUpload: File = null;
  public message: string;

  constructor(
    private dialogRef: MatDialogRef<ImageUploadComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any
    , private snackBar: MatSnackBar
    , private fileService: FileService) { 
      if (data.imageFor) {
        this.imageFor = data.imageFor
      }
    }

  fileName: string;
  fileSize: number;
  dragging: boolean = false;

  get tooBig(): boolean {
    return this.fileSize != null && this.fileSize > 100000;
  }

  get fileSizeLabel(): string {
    if (this.fileSize == null) return '';
    return this.fileSize < 1024
      ? `${this.fileSize} B`
      : `${(this.fileSize / 1024).toFixed(1)} KB`;
  }

  ngOnInit(): void {
    this.dialogRef.addPanelClass('image-upload-redesign');
  }

  preview(files: FileList) {
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    this.message = null;
    var reader = new FileReader();
    this.imagePath = files;
    this.fileToUpload = files.item(0);
    this.fileName = files[0].name;
    this.fileSize = files[0].size;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
  }

  clearSelection() {
    this.imgURL = null;
    this.imagePath = null;
    this.fileToUpload = null;
    this.fileName = null;
    this.fileSize = null;
    this.message = null;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
    if (event.dataTransfer && event.dataTransfer.files) {
      this.preview(event.dataTransfer.files);
    }
  }

  browse() {
    document.getElementById('selectedFile').click();
  }

  submit() {
    //must pick a file
    if(this.fileToUpload == null){
      this.snackBar.open('Must pick a file to upload.');
      return;
    }

    //file must not be over a certain side (100kb)
    if(this.fileToUpload.size > 100000){
      this.snackBar.open('The file selected is too big.  Please select a file that is 100KB or less.');
      return;
    }

    this.formSubmitted = true;

    this.fileService.upload(this.imageFor === 'company' ? `companyImage/{companyId}` : `userImage/{userId}`, this.fileToUpload, this.imageFor).then(data => {
      this.formSubmitted = false;
  
      this.dialogRef.close(true);
    }, error => {
      this.snackBar.open('There was an issue uploading your file.')
    });
  }
}
